import React, {FC} from 'react';

import {PaletteColorsEnum} from '../../../../../libs/shared/core/src/models/api/paletteModel';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getActivationPreferences, getCompanyName} from '../../../../store/data/company/companySelectors';
import {makeGetInbox} from '../../../../store/data/inboxes/inboxesSelectors';
import {getFirstTeamUserIsAdminOf} from '../../../../store/data/teams/teamsSelectors';
import {OnboardingGuideRightHalfContainer} from '../../guide/onboardingGuideRightHalfContainer';
import {OnboardingInboxVisual, OnboardingInboxVisualInboxPosition} from '../../welcome/onboardingInboxVisual';
import {OnboardingInboxVisualFeature} from '../../welcome/workflows/onboardingInboxIllustration';

/*
 * Props.
 */

export interface QuickInvitePopoverVisualProps {
  invitedTeammateHandles: ReadonlyArray<string>;
}

/*
 * Style.
 */

/*
 * Component.
 */

export const QuickInvitePopoverVisual: FC<QuickInvitePopoverVisualProps> = (props) => {
  const {invitedTeammateHandles} = props;

  const team = useAppSelector(getFirstTeamUserIsAdminOf);

  const companyName = useAppSelector(getCompanyName);
  const inbox = useAppSelector(
    makeGetInbox<void>(
      (state) => getActivationPreferences(state).adminOnboardingResources.inboxId ?? undefined,
    ),
  );

  return (
    <OnboardingGuideRightHalfContainer>
      <OnboardingInboxVisual
        inboxName={inbox?.name ?? 'Team inbox'}
        color={PaletteColorsEnum.PURPLE}
        companyName={companyName}
        isCircleVisualVisible={false}
        team={team}
        position={OnboardingInboxVisualInboxPosition.FAR_LEFT}
        previousPosition={undefined}
        feature={OnboardingInboxVisualFeature.INVITE_TEAMMATES}
        invitedTeammateHandles={invitedTeammateHandles}
      />
    </OnboardingGuideRightHalfContainer>
  );
};
